import SidebarTwoLevelsList from './SidebarTwoLevelsList';
import SidebarDealsList from './SidebarDealsList';
import SidebarParentIssuerList from './SidebarParentIssuerList';

export const filtersTitleMapping = {
  regionList: 'Regions & Countries',
  sectorList: 'Sectors & Subsectors',
  parentIssuerList: 'parent / issuer',
  dealList: 'Deals',
  industryList: 'Industries / Subindustries',
};

export const filtersComponentsMapping = {
  regionList: {
    component: SidebarTwoLevelsList,
    componentProps: {
      parentFilterName: 'includedRegionIds',
      filterName: 'includedCountryIds',
      parentKeyPrefix: 'region',
      childrenKeyPrefix: 'country',
      isExpanded: false,
    },
  },
  parentIssuerList: {
    component: SidebarParentIssuerList,
    componentProps: {
      filterParentName: 'includedParentIds',
      filterIssuerName: 'includedIssuerIds',
    },
  },
  dealList: {
    component: SidebarDealsList,
    componentProps: {
      filterName: 'includedDealIds',
    },
  },
  sectorList: {
    component: SidebarTwoLevelsList,
    componentProps: {
      parentFilterName: 'includedSectorIds',
      filterName: 'includedSubsectorIds',
      parentKeyPrefix: 'sector',
      childrenKeyPrefix: 'subsector',
      isExpanded: true,
    },
  },
  industryList: {
    component: SidebarTwoLevelsList,
    componentProps: {
      parentFilterName: 'includedIndustryIds',
      filterName: 'includedSubindustryIds',
      parentKeyPrefix: 'industry',
      childrenKeyPrefix: 'subindustry',
      isExpanded: true,
    },
  },
};
